<div class="mx-auto flex w-full max-w-[1600px] flex-col gap-6 px-8 py-6">

  <!-- EB-3709: Read-only banner — surfaces only when the user lacks
       amie.brandManager.write. -->
  <cmt-brand-readonly-banner />

  <!-- Hero card -->
  <section class="rounded-2xl border border-border bg-card p-6 shadow-sm">
    <div class="flex flex-wrap items-start justify-between gap-4">
      <div class="flex min-w-0 flex-1 items-center gap-7">
        @if (brand(); as b) {
          <cmt-brand-logo
            class="shrink-0"
            [domain]="b.domain"
            variant="hero"
            heightOverride="3rem"
          />
        }
        <div class="flex min-w-0 flex-col gap-1">
          <p class="cmt-eyebrow">
            <a routerLink="/admin/brands" class="text-muted-foreground hover:text-foreground">Brand Manager</a>
            @if (brand(); as b) {
              ›
              <a [routerLink]="['/admin/brands', b.id, 'edit']" class="text-muted-foreground hover:text-foreground">{{ b.name }}</a>
            }
            › Number Blocks
          </p>
          <h1 class="font-display text-3xl font-semibold leading-tight text-foreground">
            @if (brand(); as b) {
              {{ b.name }} — Number Blocks
            } @else {
              Number Blocks
            }
          </h1>
          <p class="text-sm text-muted-foreground">
            Number blocks linked to this brand.
          </p>
        </div>
      </div>

      <div class="flex flex-none items-center gap-2 pt-1">
        <button hlmBtn variant="outline" routerLink="/admin/brands">
          <hlm-icon name="lucideArrowLeft" size="0.9rem" /> Back
        </button>
      </div>
    </div>
  </section>

  <!-- Number Blocks management — the single shared panel implementation. -->
  @if (brandId(); as id) {
    <cmt-brand-number-blocks-panel [brandId]="id" [brandName]="brand()?.name ?? ''" />
  }
</div>
